import { Component, ElementRef, Output, EventEmitter, ViewChild, ViewContainerRef, Input } from '@angular/core';
import { NavController, ViewController, NavParams, ModalController, AlertController, Events, ToastController, LoadingController } from 'ionic-angular';
import { ConfigureServiceProvider } from '../../providers/configure-service/configure-service';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { DriveServiceProvider } from '../../providers/drive-service/drive-service';
import { EncrDecrServiceProvider } from '../../providers/encr-decr-service/encr-decr-service';
import { EventServiceProvider } from '../../providers/event-service/event-service';
import { LoginService } from '../../providers/login-service/login-service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { DomSanitizer } from '@angular/platform-browser';
import Cropper from 'cropperjs';
@Component({
  selector: 'manage-account',
  templateUrl: 'manage-account.html'
})

export class ManageAccountComponent {

  form: FormGroup = new FormGroup({});
  resetPasasword: FormGroup = new FormGroup({});

  user_details: boolean = false;
  sqlStatus: any = '';
  editProfile: boolean = false;
  resetPassword: boolean = false;
  emailId: any;
  screenWidth: any;
  mobileScreen: boolean = false;
  editStatus: boolean = false;
  loader: any;
  Profile: any = 'profile';
  summaryResult: any;
  boolHide: any = false;
  imageChangedEvent: any = '';
  profileImage: any = "assets/imgs/dummy_profile.jpg";
  croppedImage: any = '';
  cropperReady = false;
  filename: any;
  uploadImageFile: any;
  salutationList: any = [{
    "key": "Mr",
    "value": "Mr"
  },
  {
    "key": "Mrs",
    "value": "Mrs"
  },
  {
    "key": "Ms",
    "value": "Ms"
  }]
  fieldRequired: any = {
    "IsRequired": "YES"
  }
  constructor(public sanitizer: DomSanitizer, public spinnerService: Ng4LoadingSpinnerService, public loadingController: LoadingController, private loginServ: LoginService, private eventObj: EventServiceProvider, public driveService: DriveServiceProvider, public viewCtrlSecurity: ViewController, private popup: AlertController, private EncrDecrService: EncrDecrServiceProvider, private fb: FormBuilder, public toastCtrl: ToastController, public navCtrl: NavController, public navParams: NavParams, public configureService: ConfigureServiceProvider, private duoAuthCtrl: ModalController, public events: Events, private alertCtrl: AlertController, public toastController: ToastController, public configApiService: ConfigApiServiceProvider) {
    let loginUserDetail = this.driveService.objUserLoginDetails;
    let loginAdminId = loginUserDetail.email_id;
    this.emailId = loginAdminId;
    this.form = new FormGroup({
      profile: this.fb.group({
        "email_id": new FormControl('', Validators.email),
        "salutation": new FormControl(''),
        "name": new FormControl(''),
        "mobile_No": new FormControl('', [Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]),
        "location": new FormControl(''),
        "address": new FormControl(''),
        "city": new FormControl(''),
        "pincode": new FormControl('', Validators.pattern(/^-?(0|[1-9]\d*)?$/)),
        "companyname": new FormControl('', Validators.required),
      }),
      resetPassword: this.fb.group({
        "email_id": new FormControl('', Validators.email),
        "oldPassword": new FormControl('', Validators.required),
        "user_pwd": new FormControl('', [Validators.required]),
        "confirmPassword": new FormControl('', [Validators.required])
      }, {
        validator: this.ConfirmedValidator('user_pwd', 'confirmPassword')
      })
    })
  }

  get f() {
    return this.form.controls.profile['controls']
  }
  get r() {
    return this.form.controls.resetPassword['controls'];
  }
  ConfirmedValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
        return;
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmedValidator: true });
      } else {
        matchingControl.setErrors(null);
      }
    }
  }
  ngOnInit() {
    this.screenWidth = window.innerWidth;
    if (window.innerWidth > 700) {
      this.mobileScreen = false;
    } else {
      this.mobileScreen = true;
    }
    this.summaryResult = this.navParams.get('accSummaryData');
    setTimeout(() => {
      this.setFormData(this.summaryResult);
    }, 100);
  }

  setFormData(data) {
    this.form.controls.profile['controls']['email_id'].setValue(this.emailId);
    if (data != undefined) {
      this.profileImage = data["profile_image"] != null ? data["profile_image"] : this.profileImage;
      this.form.controls.profile['controls']['salutation'].setValue(data['Salutation']);
      this.form.controls.profile['controls']['name'].setValue(data['name']);
      this.form.controls.profile['controls']['mobile_No'].setValue(data['MobileNo']);
      this.form.controls.profile['controls']['location'].setValue(data['Country']);
      this.form.controls.profile['controls']['address'].setValue(data['Address1']);
      this.form.controls.profile['controls']['city'].setValue(data['City']);
      this.form.controls.profile['controls']['companyname'].setValue(data['CompanyName']);
      this.form.controls.profile['controls']['pincode'].setValue(data['PostalCode']);
    }
  }


  segmentChanged(e) {

    if (e["_value"] == "profile") {
      setTimeout(() => {
        this.setFormData(this.summaryResult);
      }, 100);
    } else {
      setTimeout(() => {
        this.form.controls.resetPassword['controls']['email_id'].setValue(this.emailId);
      }, 100);
    }
  }
  clearForm() {
    this.editStatus = !this.editStatus;
  }
  proccessForgotPassword() {
    let resetPwdDAta = this.form.controls.resetPassword['value'];
    var old_password = this.EncrDecrService.set('BETSYENC123$$', resetPwdDAta['oldPassword']);
    var new_password = this.EncrDecrService.set('BETSYENC123$$', resetPwdDAta['user_pwd']);
    var confirm_password = this.EncrDecrService.set('BETSYENC123$$', resetPwdDAta['confirmPassword']);
    let postResetPwdData = {};

    postResetPwdData = {
      "EmailID": this.emailId,
      "OldPassword": old_password,
      "NewPassword": new_password,
      "userid": this.configureService.getLoginUserID(),
    }

    var objData = Object.assign({}, this.configApiService.driveApi.resetPassword.params, postResetPwdData);
    this.configApiService.pushRequest(objData, this.forgotPasswordResponse);
  }

  forgotPasswordResponse = ((result) => {

    if (result == "SUCCESS") {
      let successAlert: any = '';
      successAlert = this.popup.create({
        title: 'Reset Success',
        subTitle: 'Reset Password successfully. You will be logged out from your account. Please, Login again.',
        buttons: [{
          text: 'Ok',
          handler: () => {

            this.logout();
            this.viewCtrlSecurity.dismiss();
            this.driveService.objCurrentFolder = this.driveService.getFolderStructure();
            this.driveService.objRootFolder = this.driveService.getFolderStructure();
          }
        }]
      });
      successAlert.present();
      let __this: any = this;
      successAlert.onDidDismiss(function () {
        __this.logout();
      })
    } else if (result.Result == "FAILED") {
      var pass_result = result.message;
      alert(pass_result);
    }
  })
  logout() {
    this.eventObj.trigEvent({ event: "epcDesk_CMD", data: { cmd: "logout" } });
    this.boolHide = this.loginServ.isReg()
  }

  onSubmitProfile() {
    let formValue = this.form.controls.profile['value'];
    var objData = {};
    let deskUserParam = {
      "CompanyName": formValue['companyname'],
      "EMailID": formValue['email_id'],
      "PostalCode": formValue['pincode'],
      "Country": formValue['location'],
      "Address1": formValue['address'],
      "City": formValue['city'],
      "MobileNo": formValue['mobile_No'],
      "userid": this.configureService.getLoginUserID()
    }
    objData = (Object.assign({}, this.configApiService.driveApi.pushManageAccount.params, deskUserParam));

    this.configApiService.pushRequest(objData, this.CreateAccountSubmitSuccess);
  }
  CreateAccountSubmitSuccess = ((resData) => {

    if (resData == "SUCCESS") {          
      this.viewCtrlSecurity.dismiss(true);
    }
  })
  onSubmitResetPwd() {
    if(this.form.controls["resetPassword"]["status"] == 'VALID'){
      this.proccessForgotPassword();
      this.editStatus = !this.editStatus;
    }else{
      this.form.controls["resetPassword"].markAllAsTouched();
    }
  }
  closeInfoPage() {
    this.viewCtrlSecurity.dismiss();
  } 
  editForm() {
    this.editStatus = !this.editStatus;
  }
  profileView(e) {
    this.editProfile = true;
  }
  fileTypeTrigger(e) {

    document.getElementById('imgUpload').click();
  }
  fileChangeEvent(event: any): void {
    var re = /(?:\.([^.]+))?$/;
    var ext = re.exec(event.target.files[0].name)[1];

    if (ext == 'jpg' || ext == 'jpeg' || ext == 'png' || ext == 'gif') {
      this.imageChangedEvent = event;
      this.filename = event.target.files[0].name;
    }
    else {
      alert("File is not image");
      return;
    }
  }
  imageCropped(image: string) {
    this.croppedImage = image;
  }
  imageLoaded() {
    this.cropperReady = true;
  }
  imageLoadFailed() {

  }
  removeImage() {
    this.profileImage = "assets/imgs/dummy_profile.jpg";
    this.editProfile = false;
    this.imageChangedEvent = "";
  }

  uploadImage() {
    this.presentLoading();

    this.uploadImageFile = this.baseImageURLtoFile(this.croppedImage, this.filename);
    this.readFile(this.uploadImageFile)

    this.editProfile = false;
    this.imageChangedEvent = "";
    setTimeout(() => {
      this.setFormData(this.summaryResult);
    }, 100);
    this.editStatus = true;
  }
  baseImageURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  readFile(file: any) {
    const reader = new FileReader();
    reader.onloadend = () => {
      const formData = new FormData();
      const imgBlob = new Blob([reader.result], {
        type: file.type
      });
      formData.append('file', imgBlob, file.name);
      this.uploadFileData(formData, this.loadFile);
    };
    reader.readAsArrayBuffer(file);
  }

  loadFile = ((file) => {

    this.profileImage = file;
    this.loader.dismiss();
  });

  async uploadFileData(formData, cbck) {
    this.spinnerService.show();
    var xhr = new XMLHttpRequest();
    var file_src = "";

    var url = "https://time.starport.ca:62226/phpupload/upload_file.php";
    xhr.open('POST', url, true);
    xhr.onload = function (e) {
      file_src = xhr.responseText;
      cbck(file_src);
    };
    xhr.onreadystatechange = function (aEvt) {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
        }
        else {
          alert("file size should be less than 2 MB !!");
        }
      }
    };
    xhr.send(formData);
    //
  }

  presentLoading() {
    this.loader = this.loadingController.create({
      spinner: 'ios',
      content: 'Processing Please wait...'
    });
    this.loader.present();
  }
}



// WEBPACK FOOTER //
// ./src/components/manage-account/manage-account.ts